import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

/* Types & Action Creators */

const { Types, Creators } = createActions({
  openChat: [
    "id_from",
    "id_to",
    "customer_key",
    "user_name",
    "user_avatar",
    "subscribe"
  ],
  setUsersOnline: ["users"]
});

export const ChatTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  id_from: "",
  id_to: "",
  customer_key: "",
  open_chat: false,
  user_name: "",
  user_avatar: "",
  channels: [],
  subscribe: false,
  users_online: []
});

/* Reducers */

export const openChat = (
  state,
  { id_from, id_to, customer_key, user_name, user_avatar, subscribe }
) =>
  state.merge({
    open_chat: true,
    id_from,
    id_to,
    customer_key,
    user_name,
    user_avatar,
    channels: [...state.channels, `${id_from}${id_to}${customer_key}`],
    subscribe
  });

export const setUsersOnline = (state, { users }) =>
  state.merge({
    users_online: users
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.OPEN_CHAT]: openChat,
  [Types.SET_USERS_ONLINE]: setUsersOnline
});



// WEBPACK FOOTER //
// ./src/store/ducks/chat.js